/**
 * arrowsSelectorContainer.tsx
 */
import { RailDisplayMode } from '@shared/types/enums/rail';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Get the style for the ArrowsSelectorContainer component.
 */
const getStyle = (
  displayMode: RailDisplayMode,
  displayTitle?: boolean,
  isSearch?: boolean
) => {
  switch (displayMode) {
    case RailDisplayMode.CHARACTER:
      return {
        marginTop: `${66 * Screen.widthRatio}px`,
        padding: `0 ${4 * Screen.widthRatio}px`,
        width: `${(isSearch ? 1478 : 1824) * Screen.widthRatio}px`,
      };
    case RailDisplayMode.FILTER:
      return {
        left: `${displayTitle ? 614 : -2}px`,
        marginTop: 0,
        padding: 0,
        width: `${displayTitle ? 1210 : 1824 * Screen.widthRatio}px`,
      };
    default:
      return {
        marginTop: displayTitle
          ? `${62 * Screen.widthRatio}px`
          : `${4 * Screen.widthRatio}px`,
        padding: `0 ${4 * Screen.widthRatio}px`,
        width: `${(isSearch ? 1478 : 1824) * Screen.widthRatio}px`,
      };
  }
};

/**
 * Styled component for the ArrowsSelectorContainer component.
 */
const ArrowsSelectorContainer = styled.div<{
  displayMode: RailDisplayMode;
  displayTitle?: boolean;
  isSearch?: boolean;
}>`
  ${(props) => {
    const { left, marginTop, padding, width } = getStyle(
      props.displayMode,
      props.displayTitle,
      props.isSearch
    );
    return `    
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    left: ${left};
    margin-top: ${marginTop};
    padding: ${padding};
    pointer-events: none;
    position: fixed;
    width: ${width};
`;
  }}
`;

export default ArrowsSelectorContainer;
